var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play-btn"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.4244 63.8487C50.0557 63.8487 64.3487 49.5557 64.3487 31.9244C64.3487 14.293 50.0557 0 32.4244 0C14.793 0 0.5 14.293 0.5 31.9244C0.5 49.5557 14.793 63.8487 32.4244 63.8487Z",
    fill: "url(#paint0_linear_232_6630)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.85156 54.4974C12.8087 57.4945 16.3295 59.877 20.2113 61.5077C24.093 63.1385 28.2589 63.9853 32.4693 63.9994C36.6796 64.0135 40.8512 63.1947 44.7437 61.5899C48.6363 59.9852 52.173 57.6264 55.1502 54.6492C58.1273 51.672 60.4862 48.1353 62.0909 44.2428C63.6956 40.3502 64.5145 36.1786 64.5004 31.9683C64.4863 27.758 63.6395 23.592 62.0087 19.7103C60.378 15.8286 57.9955 12.3077 54.9984 9.35059L9.85156 54.4974Z",
    fill: "url(#paint1_linear_232_6630)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    filter: "url(#filter0_d_232_6630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6144 29.4382L27.5592 20.6576C27.181 20.4335 26.7498 20.3145 26.3102 20.313C25.8707 20.3115 25.4387 20.4274 25.0589 20.6489C24.6294 20.9064 24.275 21.2722 24.0312 21.7097C23.7875 22.1472 23.663 22.6411 23.6702 23.1419V40.7003C23.663 41.201 23.7875 41.6949 24.0312 42.1324C24.275 42.57 24.6294 42.9358 25.0589 43.1933C25.4388 43.415 25.8711 43.5311 26.311 43.5296C26.7508 43.528 27.1823 43.4089 27.5606 43.1846L42.6159 34.4039C43.0359 34.1395 43.382 33.773 43.6218 33.3385C43.8617 32.9041 43.9875 32.4159 43.9875 31.9196C43.9875 31.4233 43.8617 30.9352 43.6218 30.5007C43.382 30.0663 43.0359 29.6997 42.6159 29.4353L42.6144 29.4382Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    filter: "url(#filter1_d_232_6630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6144 29.4387L30.7995 22.5474L23.6702 27.3955V40.7036C23.663 41.2044 23.7875 41.6983 24.0312 42.1358C24.275 42.5733 24.6294 42.9391 25.0589 43.1966C25.4388 43.4183 25.8711 43.5344 26.311 43.5329C26.7508 43.5314 27.1823 43.4123 27.5606 43.1879L42.6159 34.4073C43.0359 34.1429 43.382 33.7763 43.6218 33.3419C43.8617 32.9074 43.9875 32.4192 43.9875 31.923C43.9875 31.4267 43.8617 30.9385 43.6218 30.5041C43.382 30.0696 43.0344 29.7031 42.6144 29.4387Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_232_6630",
    x: 19.6699,
    y: 20.313,
    width: 28.3174,
    height: 31.2168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_232_6630"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_232_6630",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_232_6630",
    x: 19.6699,
    y: 22.5474,
    width: 28.3174,
    height: 28.9854,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_232_6630"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_232_6630",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_232_6630",
    x1: 5.60354,
    y1: 3.58423,
    x2: 60.0201,
    y2: 61.0844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA71E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE502D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_232_6630",
    x1: 33.39,
    y1: 32.947,
    x2: 59.5926,
    y2: 61.1391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF0000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF0000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtn);
export default __webpack_public_path__ + "static/media/play-btn.5ccc1f830fbd5b615f9ee9d2b3f72ead.svg";
export { ForwardRef as ReactComponent };